import { createSelector } from 'reselect'
import { entitySelector, resultsSelector } from 'containers/Entity/selectors'
import { getMonthDateYearTimestampString } from 'helpers/DateUtil'
import cloneDeep from 'lodash/cloneDeep'
import { HEALTH_COLORS } from './constants'

const aeDetailsEntitySelector = createSelector(
  entitySelector,
  (entities) => entities.project_ae_detail_views
    ? entities.project_ae_detail_views
    : {}
)

const aeDetailsResultSelector = createSelector(
  resultsSelector,
  (results) => results.project_ae_detail_views
    ? results.project_ae_detail_views
    : []
)

const aeDetailsChangeSelector = state => state.project.projectExecution.aeDetailsChange
  ? state.project.projectExecution.aeDetailsChange
  : {}

const aeDetailsSelectionEntitySelector = createSelector(
  entitySelector,
  (entities) => entities.ae_details_selections 
    ? entities.ae_details_selections
    : {}
)

const aeDetailsSelector = createSelector(
  aeDetailsEntitySelector,
  (entity) => {
    if(Object.values(entity)[0]){
      return cloneDeep(Object.values(entity)[0])
    } else {
      return {}
    }
  }
)

const aeResourceLevelOptionsSelector = createSelector(
  aeDetailsSelectionEntitySelector,
  (entity) => {
    if(Object.values(entity)[0] && Object.values(entity)[0].aeResourceLevels){
      var aeResourceLevels = Object.values(entity)[0].aeResourceLevels
      var toReturn = []
      Object.values(aeResourceLevels).forEach((aeResourceLevel) => {
        toReturn.push({ value: aeResourceLevel.id, label: aeResourceLevel.level.toString()})
      })
      return toReturn
    } else {
      return []
    }
  }
)

const projectHealthOptionsSelector = createSelector(
  aeDetailsSelectionEntitySelector,
  (entity) => {
    if(Object.values(entity)[0] && Object.values(entity)[0].projectHealths){
      var projectHealths = Object.values(entity)[0].projectHealths
      var toReturn = []
      Object.values(projectHealths).forEach((projectHealth) => {
        toReturn.push({
          value: projectHealth.id, 
          label: projectHealth.health, 
          color: {
            backgroundColor: HEALTH_COLORS[projectHealth.health.toLowerCase()]
          } 
        })
      })
      return toReturn
    } else {
      return []
    }
  }
)

const aeResourceLevelIdSelector = createSelector(
  aeDetailsChangeSelector,
  (aeDetailsChange) => aeDetailsChange.aeResourceLevelId != null
  ? aeDetailsChange.aeResourceLevelId
  : ''
)

const projectHealthIdSelector = createSelector(
  aeDetailsChangeSelector,
  (aeDetailsChange) => aeDetailsChange.projectHealthId 
  ? aeDetailsChange.projectHealthId
  : ''
)

const aeNotesSelector = createSelector(
  aeDetailsChangeSelector,
  (aeDetailsChange) => aeDetailsChange.aeNotes 
  ? aeDetailsChange.aeNotes
  : ''
)

const projectWaiverSelector = createSelector(
  aeDetailsChangeSelector,
  (aeDetailsChange) => aeDetailsChange.projectWaiver 
  ? aeDetailsChange.projectWaiver
  : ''
)

const aeDetailsIdSelector = createSelector(
  aeDetailsChangeSelector,
  (aeDetailsChange) => aeDetailsChange.id 
  ? aeDetailsChange.id
  : ''
)

const aeDetailsLastUpdatedNameSelector = createSelector(
  aeDetailsChangeSelector,
  (aeDetailsChange) => aeDetailsChange.lastUpdateUserName
  ? aeDetailsChange.lastUpdateUserName
  : ''
)

const aeDetailsLastUpdatedDateSelector = createSelector(
  aeDetailsChangeSelector,
  (aeDetailsChange) => aeDetailsChange.updatedAt
  ? getMonthDateYearTimestampString(new Date(aeDetailsChange.updatedAt))
  : ''
)

const aeDetailsParamsSelector = createSelector(
  aeResourceLevelIdSelector,
  projectHealthIdSelector,
  aeNotesSelector,
  projectWaiverSelector,
  (aeResourceLevelId, projectHealthId, aeNotes, projectWaiver) => ({
    aeResourceLevelId,
    projectHealthId,
    aeNotes,
    projectWaiver
  })
)

export {
  aeDetailsSelector,
  aeDetailsEntitySelector,
  aeResourceLevelOptionsSelector,
  projectHealthOptionsSelector,
  aeResourceLevelIdSelector,
  projectHealthIdSelector,
  aeNotesSelector,
  projectWaiverSelector,
  aeDetailsIdSelector,
  aeDetailsParamsSelector,
  aeDetailsLastUpdatedNameSelector,
  aeDetailsLastUpdatedDateSelector
}
